<template>
  <md-button
    class="md-just-icon md-success md-simple table-action"
    @click.native="triggerDetail"
    v-if="item.hasDetail"
  >
    <md-icon>visibility</md-icon>
  </md-button>
</template>
<script>
export default {
  props: ["item"],
  inject: ["viewReportDetail"],
  methods: {
    triggerDetail() {
      this.viewReportDetail(this.item);
    }
  }
};
</script>
